import React from 'react';
import styled from 'styled-components';
import { Label } from './Label';

// Styled Components
const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const StyledInput = styled.input<{ $disabled?: boolean }>`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: ${props => props.$disabled ? props.theme.muted : props.theme.background};
  color: ${props => props.$disabled ? props.theme.mutedForeground : props.theme.foreground};
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: ${props => props.theme.primary};
    box-shadow: 0 0 0 2px ${props => props.theme.primary}20;
  }
  
  &:hover:not(:disabled) {
    border-color: ${props => props.theme.border};
  }
  
  &::placeholder {
    color: ${props => props.theme.mutedForeground};
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const ErrorText = styled.span`
  font-size: 12px;
  color: ${props => props.theme.destructive};
  margin-top: 4px;
`;

// Types
interface ModalInputProps {
  id?: string;
  label?: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  required?: boolean;
}

// Component
export const ModalInput: React.FC<ModalInputProps> = ({
  id,
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  disabled = false,
  error,
  required = false,
}) => {
  return (
    <InputContainer>
      {label && (
        <div style={{ fontSize: '14px', fontWeight: '500', color: 'var(--text)' }}>
          <Label htmlFor={id}>
            {label}
            {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
          </Label>
        </div>
      )}
      <StyledInput
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        $disabled={disabled}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </InputContainer>
  );
};
